import axios from "axios";

const API_URL = process.env.REACT_APP_MASTER_API;

export async function getAllDepartments() {
  let url = API_URL + "/alldepartments";
  let response = await axios.get(url);
  return response.data;
}

export async function getActiveDepartments() {
  let url = API_URL + "/activedepartments";
  let response = await axios.get(url);
  return response.data;
}

export async function getNextDeptId() {
  let url = API_URL + "/nextdeptid";
  let response = await axios.get(url);
  return response.data;
}

export const addNewDepartment = async (department) => {
  let url = `${API_URL}/adddepartment`;
  const response = await axios.post(url, department);
  return response.data;
};

export const deleteDepartment = async (department) => {
  let url = `${API_URL}/deletedepartment`;
  const response = await axios.post(url, department);
  return response.data;
};